const UserMessage = ({ text }) => {
  return (
    <div className="flex items-start gap-3">
      <picture className="relative h-10 w-10">
        <img
          src="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50"
          alt=""
          className="w-full rounded-full border-2 border-secondary"
        />
      </picture>
      <div>
        <p className="font-pop text-xs font-medium text-blue">Bencroft</p>
        <p className="my-1 rounded-[10px] rounded-tl-none bg-quantityColor px-3 py-[5px] font-pop text-xl text-black">
          {text}
        </p>
        <p className="font-pop text-xs text-chatLightGray">
          12 July 2022, 02:03:28 am
        </p>
      </div>
    </div>
  );
};

export default UserMessage;
